import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import starFill from '@iconify/icons-eva/star-fill';
import { SvgIcon } from '@material-ui/core';
const ICON_SMALL = { width: 20, height: 20 };
const ICON_LARGE = { width: 28, height: 28 };
const ICON = (_jsx(SvgIcon, { children: _jsx(Icon, { icon: starFill }, void 0) }, void 0));
export default function Rating(theme) {
    return {
        MuiRating: {
            defaultProps: {
                emptyIcon: ICON,
                icon: ICON,
            },
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        opacity: 0.48,
                    },
                },
                iconEmpty: { color: theme.palette.grey[50048] },
                sizeSmall: { '& svg': { ...ICON_SMALL } },
                sizeLarge: { '& svg': { ...ICON_LARGE } },
            },
        },
    };
}
//# sourceMappingURL=Rating.js.map